import { render, staticRenderFns } from "./PagoRechazado.vue?vue&type=template&id=a4d69d20&"
import script from "./PagoRechazado.vue?vue&type=script&lang=js&"
export * from "./PagoRechazado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports